import { getCostList } from '@/api/wenjuan/cost'
import { extendObject } from '@/assets/js/utils'

// 获取列表
export function getList(params) {
  // console.log(JSON.stringify(params, null, 2))
  let channelMap = {
    0: {
      text: '网络调查'
    },
    1: {
      text: '督导任务'
    },
    2: {
      text: '面对面访问'
    }
  }
  /* let approveTypeMap = {
    0: {
      text: '人工一审'
    },
    1: {
      text: '人工二审'
    },
  } */
  let approveTypeMap = {
    0: {
      text: '预审'
    },
    /* 1: {
      text: '人工质控'
    },
    2: {
      text: '自动过审'
    }, */
    1: {
      text: '自动过审'
    },
    2: {
      text: '人工审核'
    },
    3: {
      text: '批量审核'
    },
    4: {
      text: '质控题'
    }
  }
  let sendStatusMap = ['失败', '成功', '等待'] // 发放状态
  this.loading = true
  getCostList(params)
    .then(res => {
      this.page.total = res.data.data.total
      this.page.currentPage = res.data.data.current
      this.page.pageSize = res.data.data.size
      this.data = res.data.data.records.map(val => {
        return {
          // 通用
          answerId: val.answerId, // 答卷ID
          surveyId: val.surveyId, // 问卷ID
          codes: val.accountRecordId, // 费用产生流水号
          jlName: val.awardName, // 任务名称， 子渠道
          jobId: val.jobId, // 奖励id
          examType: approveTypeMap[val.approveType] && approveTypeMap[val.approveType].text, // 审核
          times: val.createTime, // 创建时间
          sentTime: val.sentTime, // 发放/退款时间
          money: val.amount,
          sendStatus: sendStatusMap[val.sendStatus],
          // 全部
          name: channelMap[val.channel] && channelMap[val.channel].text,
          yangId: val.accountUserId,
          // 督导审核 面对面访问
          userLower: val.supervisorName,
          user: val.interviewerName
        }
      })
      // 如果当前查询页数 没有数据 往前一页查询一次
      if (this.data.length === 0 && this.page.currentPage != 1) {
        this.page.currentPage--
        if (this.page.currentPage > 0) {
          params.current = this.page.currentPage
          getList(params)
        }
      }
      this.loading = false
    })
    .catch(err => {
      console.log(err)
      // return err
    })
}

// 督导吧任务 和 面对面访问
export const lineDownOptions = {
  excelBtn: true,
  column: [
    /* {
      width: 200,
      label: "流水号", //佣金产生流水号
      value: "codes",
    }, */ {
      width: 170,
      label: '答卷ID',
      value: 'answerId',
      fixed: true
    },
    {
      label: '任务名称',
      value: 'jlName',
      slot: true
    },
    {
      label: '调查员',
      value: 'user'
    },
    /* {
      label: "督导",
      value: "userLower",
    }, */
    {
      label: '审核方式',
      value: 'examType'
    },
    {
      label: '佣金金额(元)',
      value: 'money',
      width: 100
    },
    {
      width: 200,
      label: '佣金产生时间',
      value: 'times'
    }
  ]
}
// 全部 答题奖励
export const costAnswerOptions = {
  column: [
    /* {
      width: 150,
      label: "费用产生流水号",
      value: "codes",
    },  */
    {
      width: 170,
      label: '答卷ID',
      value: 'answerId',
      fixed: true
    },
    {
      width: 210,
      label: '子渠道',
      value: 'jlName'
    },
    {
      width: 150,
      label: '答卷样本ID',
      value: 'yangId'
    },
    {
      label: '审核方式',
      value: 'examType'
    },
    {
      width: 100,
      label: '奖励金额(元)',
      value: 'money'
    },
    {
      width: 180,
      label: '奖励产生时间',
      value: 'times'
    },
    {
      label: '发放状态',
      value: 'sendStatus'
    }
  ]
}
// 全部 分享奖励
export const costSpreadOptions = {
  column: [
    /* {
      width: 150,
      label: "奖励产生流水号",
      value: "codes",
    },  */
    {
      width: 170,
      label: '答卷ID',
      value: 'answerId',
      fixed: true
    },
    {
      width: 100,
      label: '回收渠道',
      value: 'name'
    },
    {
      width: 210,
      label: '子渠道',
      value: 'jlName',
      slot: true
    },
    {
      width: 150,
      label: '答卷样本ID',
      value: 'yangId'
    },
    {
      label: '审核方式',
      value: 'examType'
    },
    {
      width: 100,
      label: '奖励金额(元)',
      value: 'money'
    },
    {
      width: 180,
      label: '奖励产生时间',
      value: 'times'
    },
    {
      label: '发放状态',
      value: 'sendStatus'
    },
    {
      width: 180,
      label: '发放/退款时间',
      value: 'sentTime'
    }
  ]
}
// 网调 答题奖励
export const costNetAnswerOptions = {
  column: [
    /*     {
          width: 150,
          label: "奖励产生流水号",
          value: "codes",
        },  */
    {
      width: 170,
      label: '答卷ID',
      value: 'answerId',
      fixed: true
    },
    {
      width: 210,
      label: '子渠道',
      value: 'jlName'
    },
    {
      width: 150,
      label: '答卷样本ID',
      value: 'yangId'
    },
    {
      label: '审核方式',
      value: 'examType'
    },
    {
      width: 100,
      label: '奖励金额(元)',
      value: 'money'
    },
    {
      width: 180,
      label: '奖励产生时间',
      value: 'times'
    },
    {
      label: '发放状态',
      value: 'sendStatus'
    },
    {
      width: 180,
      label: '发放/退款时间',
      value: 'sentTime'
    }
  ]
}
// 网调 分享奖励
export const costNetSpreadOptions = {
  column: [
    /* {
      width: 180,
      label: "奖励产生流水号",
      value: "codes",
    },  */
    {
      width: 170,
      label: '答卷ID',
      value: 'answerId',
      fixed: true
    },
    {
      width: 180,
      label: '传播样本ID',
      value: 'yangId'
    },
    {
      width: 210,
      label: '子渠道',
      value: 'jlName'
    },
    {
      width: 100,
      label: '奖励金额(元)',
      value: 'money'
    },
    {
      width: 180,
      label: '奖励产生时间',
      value: 'times'
    },
    {
      label: '发放状态',
      value: 'sendStatus'
    },
    {
      width: 180,
      label: '发放/退款时间',
      value: 'sentTime'
    }
  ]
}

export const publicPage = {
  total: 0,
  currentPage: 1,
  pageSize: 20,
  pageSizes: [10, 20, 30, 50, 100],
  background: true
}
